import * as React from 'react';
import {
  ActionCard,
  Permission,
  RouteWrapper,
  Section,
  Content,
  Box,
  HeadingSection,
} from '../components';

const Route = () => (
  <RouteWrapper title="Settings" requireAuth>
    <HeadingSection title="Settings" />
    <Section>
      <Content>
        <Box>
          <Permission require="MANAGE_SETTINGS">
            <ActionCard
              title="Global Settings"
              subtitle="Manage global booking system settings"
              icon="cog"
              link="/settings/settings"
            />
          </Permission>
          <Permission require="MANAGE_USERS">
            <ActionCard
              title="Users"
              subtitle="Manage users and their permissions"
              icon="users"
              link="/settings/users"
            />
          </Permission>
          <Permission require="MANAGE_VEHICLES">
            <ActionCard
              title="Vehicles"
              subtitle="Manage vehicles and vehicle types"
              icon="truck"
              link="/settings/vehicles"
            />
          </Permission>
          <Permission require="MANAGE_HOLIDAYS">
            <ActionCard
              title="Holidays"
              subtitle="Manage holidays and blackout days"
              icon="calendar"
              link="/settings/holidays"
            />
          </Permission>
          <Permission require="MANAGE_ACCESSORIES">
            <ActionCard
              title="Accessories"
              subtitle="Manage booking accessories and prices"
              icon="shopping-bag"
              link="/settings/accessories"
            />
          </Permission>
        </Box>
      </Content>
    </Section>
  </RouteWrapper>
);

export default Route;
